import Axios from 'axios';
import { store } from '../store';
import { router } from '../router';
import Config from '../../config/app';

export const axios = Axios.create({
	baseURL: Config.baseURL,
	
	headers: {
		'X-Requested-With': 'XMLHttpRequest',
	}
});

// Intercept each request and set the bearer token for user
axios.interceptors.request.use((config) => {
	let apiToken = store.getters['User/getUser'].api_token;

	if (apiToken && !config.headers.common.Authorization) {
		config.headers.common.Authorization = `Bearer ${apiToken}`;
	}

	return config;
});


// WEBPACK FOOTER //
// ./src/services/index.js